import { render, staticRenderFns } from "./page2Svg.vue?vue&type=template&id=7663bb08&"
import script from "./page2Svg.vue?vue&type=script&lang=js&"
export * from "./page2Svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports